
export default class InputLocationCache {
    private data: string = ''
    constructor() {
        this.data = ''
    }

    get() {
        return this.data
    }

    clear() {
        this.data = ''
    }
    set(data: string) {
        this.data = data
    }

}

export const inputLocationCache = new InputLocationCache()